var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510 296.315v-82.629l-69.827-19.95c-2.983-9.013-6.639-17.822-10.925-26.332l35.278-63.502-58.427-58.428-63.502 35.279c-8.51-4.287-17.319-7.942-26.332-10.925l-19.95-69.828h-82.629l-19.951 69.828c-9.012 2.983-17.821 6.639-26.331 10.925l-63.502-35.279-58.428 58.428 35.279 63.502c-4.287 8.511-7.942 17.32-10.926 26.332l-69.827 19.95v82.629l69.827 19.951c2.983 9.011 6.639 17.821 10.926 26.332l-35.279 63.502 58.428 58.427 63.502-35.278c8.509 4.287 17.318 7.941 26.331 10.925l19.951 69.826h82.629l19.951-69.827c9.012-2.983 17.822-6.639 26.332-10.926l63.502 35.279 58.427-58.427-35.279-63.502c4.287-8.51 7.942-17.319 10.926-26.332zm-82.688 104.572-26.425 26.425-58.153-32.307c-4.655 2.341-19.236 12.141-42.737 18.787l-8.044 2.275-18.268 63.933h-37.371l-18.267-63.934c-4.93-1.635-22.002-4.958-43.482-16.978l-7.298-4.084-58.153 32.307-26.425-26.425 32.307-58.152c-2.321-4.616-12.143-19.241-18.786-42.737l-2.274-8.045-63.936-18.266v-37.371l63.935-18.267c1.631-4.919 4.955-21.999 16.977-43.483l4.084-7.298-32.307-58.152 26.426-26.426 58.152 32.307c4.646-2.336 19.237-12.141 42.737-18.786l8.044-2.275 18.266-63.935h37.371l18.267 63.934c4.91 1.628 22 4.957 43.483 16.978l7.298 4.083 58.152-32.307 26.425 26.425-32.307 58.153c2.319 4.611 12.141 19.235 18.787 42.737l2.275 8.045 63.935 18.266v37.371l-63.934 18.267c-1.633 4.925-4.958 22.002-16.978 43.483l-4.083 7.298z",
    fill: "#ff0000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 120c-74.439 0-135 60.561-135 135s60.561 135 135 135 135-60.56 135-135-60.56-135-135-135zm0 240c-57.897 0-105-47.103-105-105s47.103-105 105-105 105 47.103 105 105-47.103 105-105 105z",
    fill: "#ff0000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 300h30v30h-30z",
    fill: "#ff0000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 180h30v90h-30z",
    fill: "#ff0000",
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuit);
export default __webpack_public_path__ + "static/media/circuit.8b0dbc0d81580d253235a9d4a6bb01c8.svg";
export { ForwardRef as ReactComponent };